import hk from './hk'
import th from './th'

/** @type {'hk'|'th'} */
const REACT_APP_REGION = process.env.REACT_APP_REGION || 'hk'

/** @type {IApiConfigs} */
const configs = {
  hk,
  th,
}

const exportConfig = configs[REACT_APP_REGION] || hk

export default exportConfig
